<div class="state-item" *ngIf="order">
  <span class="state-image">
    <img [src]="paymentIcon">
  </span>
  <span class="state-text" *ngIf="order.processor === 'credits'">{{order.total_credits}} credits</span>
  <span class="state-text" *ngIf="type === 'gmg'">$0.00 USD</span>
  <span class="state-text" *ngIf="type !== 'gmg' && order.processor !== 'credits'">${{amount}} USD</span>
</div>
